import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import { ConfigService } from '../../../../config.service';
import { ApiFollowUpService } from '../../../../apiServices/followUp/api-follow-up.service';
import { DataStorageService } from '../../../../data-storage.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stages',
  templateUrl: './stages.component.html',
  styleUrls: ['./stages.component.scss']
})
export class StagesComponent implements OnInit, DoCheck, OnDestroy {
  dates: any[];
  oldDates: any[];
  oldFollowUpLength: number;
  salesStage: string[];
  nextStep: string[];
  constructor(
    public dataStorageService: DataStorageService,
    public config: ConfigService,
    public api: ApiFollowUpService) {
    this.dates = [];
    this.oldDates = [];
    this.oldFollowUpLength = 0;
    this.api.getSalesStage().then(data => this.salesStage = data);
    this.api.getNextStep().then(data => this.nextStep = data);


  }

  waitForFollowUps(): Promise<any> {
    if (this.dataStorageService.currentState.metaData.length > 0) {
      return new Promise<any>(resolve => {
        resolve();
      });
    } else {
      return new Promise<any>(resolve => {
        const handler = setInterval(() => {
          if (this.dataStorageService.currentState.metaData.length > 0) {
            clearInterval(handler);
            resolve();
          }
        }, 100);
      });
    }
  }

  ngOnInit() {
    this.waitForFollowUps().then(() => {
      this.dataStorageService.currentState.metaData.map((element) => {
        this.dates.push(this.convertStringToDate(element.nextDate));
      });
    });
  }

  ngDoCheck(): void {
    let changeDetected = false;
    this.dataStorageService.currentState.metaData.forEach((e, i) => {
      const date = this.dates[i];
      if (date !== this.oldDates[i]) {
        changeDetected = true;
        this.oldDates[i] = date;
        this.dataStorageService.currentState.metaData[i].nextDate = this.convertDateToBackendFormat(date);
      }
      if (this.oldFollowUpLength < this.dataStorageService.currentState.metaData.length) {
        this.oldFollowUpLength = this.dataStorageService.currentState.metaData.length;
        this.dates = [];
        this.oldDates = [];
        this.ngOnInit();
      }

    });
    if (changeDetected) {
      this.api.putFollowUp();
    }
  }

  ngOnDestroy() {
    this.dates = [];
    this.oldDates = [];
    this.dataStorageService.currentState.metaData = [];
  }

  updateFollowUp(oldVal: string, value: string, followUpIndex: number) {
    if (this.dataStorageService.currentState.status !== 'OPEN') {
      this.dataStorageService.currentState.metaData[followUpIndex].salesStage = oldVal;
      alert('This offer is CLOSED');
    } else {
    this.api.putFollowUp();
    }
  }

  removeFollowUp(followUpID: number, index: number) {
    this.api.deleteFollowUp(followUpID).then(() => {
      this.dates.splice(index, 1);
      this.dataStorageService.currentState.metaData.splice(index, 1);
    });
  }

  convertDateToBackendFormat(date: NgbDateStruct): string {
    const day = date.day < 10 ? '0' + date.day : date.day;
    const month = date.month < 10 ? '0' + date.month : date.month;
    const year = date.year;
    return year + '-' + month + '-' + day;
  }

  convertStringToDate(date: string): NgbDateStruct {

    let splitted = [];
    if (date) {
      splitted = date.split('-');
    }

    if (splitted.length > 0) {
      const effect: NgbDateStruct = {year: null, month: null, day: null};
      if (splitted[0].length === 4) {
        effect.day = parseInt(splitted[2], 10);
        effect.month = parseInt(splitted[1], 10);
        effect.year = parseInt(splitted[0], 10);
        return effect;
      } else {
        effect.day = parseInt(splitted[0], 10);
        effect.month = parseInt(splitted[1], 10);
        effect.year = parseInt(splitted[2], 10);
        return effect;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/content/my-offers/follow-up/stages/stages.component.ts